import type { EVENT_ANALYTIC } from '~/modules/tracking';

import {
  usePricingPlanActive,
  usePricingPlanPaidActive,
  usePricingPlanTrialActive,
  usePricingStore,
} from '~/modules/pricing';
import { getConfig } from '~/config/environment';
import { useCallback, useEffect } from 'react';
import { useShopStore } from '~/stores/shop';
import { isBrowser } from '~/utils';

export const useTrackingAnalytic = () => {
  const shopInfo = useShopStore((state) => state.shopInfo);

  const { activePlanKey } = usePricingPlanActive();
  const { trialPlanKey } = usePricingPlanTrialActive();
  const { paidPlanKey } = usePricingPlanPaidActive();

  const trackEvent = useCallback(
    (event: EVENT_ANALYTIC, payload: { [key: string]: any }) => {
      if (!shopInfo || !isBrowser()) return;

      window?.gtag?.('event', event, {
        ...payload,
        store_id: shopInfo?.shopID,
        shopify_plan: shopInfo?.shopifyPlan,
        shopify_domain: shopInfo?.shopifyDomain,
        timestamp: new Date().toISOString(),
        plan_paid_key: paidPlanKey,
        plan_trial_key: trialPlanKey,
        plan_active_key: activePlanKey,
        send_to: getConfig('INTEGRATION')?.APP_GA_MEASUREMENT_ID,
      });
    },
    [shopInfo, paidPlanKey, trialPlanKey, activePlanKey],
  );

  return {
    trackEvent,
  };
};

export const useTrackingPageViewAnalytic = ({ event }: { event: EVENT_ANALYTIC }) => {
  const shopInfo = useShopStore((state) => state.shopInfo);
  const shopPlatformPlanActive = usePricingStore((state) => state.shopPlatformPlanActive);
  const { trackEvent } = useTrackingAnalytic();

  useEffect(() => {
    if (!shopInfo || !shopPlatformPlanActive || !isBrowser()) return;

    trackEvent(event, {});
  }, [event, shopInfo, shopPlatformPlanActive, trackEvent]);
};
